import React from 'react';
import css from './ControlGroupIcon.css';
import Icon, { IconSizes, IconTypes } from '../../components/foundations/Icon';

const ControlGroupIcon = () => (
    <div className={css.testChannelIconWrapper}>
        <Icon className={css.testChannelIcon} size={IconSizes.SMALL} type={IconTypes.MINGCUTE} name="flask-line" />
    </div>
);

export default ControlGroupIcon;
